// extracted by mini-css-extract-plugin
module.exports = {"cellCustom":"cell_cellCustom__2RGtO"};